export const portfolio = Object.freeze({
  profile: {
    nameZh: "林哲然",
    nameEn: "Zheran Lin",
    role: "创意技术总监 / Creative Technology Director",
    location: "Shanghai",
    biography:
      "林哲然是一位常驻上海的创意技术总监，带领 6–10 人跨学科团队，在设计、技术与公共文化之间构建具有情绪和参与感的体验。他负责创意方向与整体交付，同时亲自把关交互模型、实时视觉和关键技术原型。"
  },
  navigation: [
    { id: "hero", label: "Index" },
    { id: "manifesto", label: "Method" },
    { id: "projects", label: "Experiments" },
    { id: "practice", label: "Practice" },
    { id: "contact", label: "Contact" }
  ],
  hero: {
    eyebrow: "ZHERAN LIN / CREATIVE TECHNOLOGY DIRECTOR",
    headline: ["IDEAS", "BECOME", "SYSTEMS"],
    statement: "把复杂技术变成具有情绪和参与感的公共体验。",
    contactLabel: "Start a conversation",
    contactHref: "mailto:hello@zheran.example"
  },
  manifesto: [
    { number: "01", text: "把复杂技术变成公共体验", keyword: "体验" },
    { number: "02", text: "用系统制造意外", keyword: "意外" },
    { number: "03", text: "让互动拥有情绪", keyword: "情绪" }
  ],
  projects: [
    {
      id: "city-signal",
      number: "01",
      titleZh: "城市信号",
      titleEn: "City Signal",
      year: "2025",
      description:
        "针对城市声音难以被直观感知的问题，带领团队将环境声场转化为实时视觉；负责创意方向、交互模型与关键视觉原型，并协调声音、空间和工程系统完成现场整合。项目最终作为沉浸式装置公开展出。",
      result: "沉浸式装置 / 公开展出",
      media: {
        src: null,
        poster: "/assets/posters/city-signal.svg",
        alt: "城市信号项目的抽象编辑海报"
      }
    },
    {
      id: "second-skin",
      number: "02",
      titleZh: "第二层皮肤",
      titleEn: "Second Skin",
      year: "2024",
      description:
        "围绕身体动作如何驱动数字材料生成展开探索，带领团队建立姿态输入、生成逻辑与实时渲染之间的体验链路；负责视觉系统与关键交互原型。项目最终以时装、影像和互动装置结合的形式公开展出。",
      result: "时装 × 影像 × 互动装置",
      media: {
        src: null,
        poster: "/assets/posters/second-skin.svg",
        alt: "第二层皮肤项目的抽象编辑海报"
      }
    },
    {
      id: "memory-theater",
      number: "03",
      titleZh: "记忆剧场",
      titleEn: "Memory Theater",
      year: "2023",
      description:
        "围绕碎片化记忆的非线性特征，设计由文字、声音与参与者共同生成的空间体验；负责叙事结构、AI 原型边界与舞台视觉方向，并带领团队完成现场系统。项目最终形成由观众参与推进的公开展览。",
      result: "参与式空间叙事 / 公开展览",
      media: {
        src: null,
        poster: "/assets/posters/memory-theater.svg",
        alt: "记忆剧场项目的抽象编辑海报"
      }
    }
  ],
  experience: [
    {
      period: "2022—26",
      studio: "Asterism Lab",
      role: "创意技术总监",
      description:
        "带领 6–10 人跨学科团队完成互动装置、实时视觉与生成式体验；建立从创意提案、关键原型到现场交付的协作流程，并亲自把关核心交互与视觉系统。"
    },
    {
      period: "2019—22",
      studio: "Field Note Studio",
      role: "高级创意技术师",
      description:
        "连接设计、工程与空间制作团队，为公共展览开发实时图形和交互原型；将实验性概念转化为可安装、可维护的现场系统。"
    },
    {
      period: "2016—19",
      studio: "Parallel Unit",
      role: "互动设计师",
      description:
        "使用网页技术、传感器与动态图形制作互动体验，参与概念设计、原型开发和现场调试，建立跨越屏幕与物理空间的创作方法。"
    }
  ],
  capabilities: [
    {
      number: "01",
      name: "Creative Direction",
      description: "概念建立、叙事框架、团队领导与整体交付"
    },
    {
      number: "02",
      name: "Realtime Graphics",
      description: "WebGL、TouchDesigner 与实时视觉系统"
    },
    {
      number: "03",
      name: "AI Prototyping",
      description: "生成式交互、模型体验设计与原型评估"
    },
    {
      number: "04",
      name: "Spatial Experience",
      description: "传感器、装置交互、展览与舞台体验"
    }
  ],
  exhibitions: [
    { year: "2025", title: "Synthetic Futures", detail: "群展，上海" },
    { year: "2024", title: "Digital Habitat", detail: "特别展览单元，深圳" }
  ],
  contact: {
    headline: ["MAKE", "SOMETHING", "IMPOSSIBLE."],
    availability: "Shanghai / Available for selected collaborations",
    email: "hello@zheran.example",
    href: "mailto:hello@zheran.example"
  },
  disclosure:
    "本站为虚构人物与概念作品集演示，所有经历、项目和展览均为创作设定。"
});
